import { createClient } from "@supabase/supabase-js";
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_APIKEY;
const supabase = createClient(supabaseUrl, supabaseKey);

export default supabase;
